import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { IdentityService } from '../../../core/services/identity.service';
import { MessagesInteractionService } from '../../../messages/services/messages-interaction.service';
import { MessagesDataService } from '../../../messages/services/messages.service';
import { RouterUtil } from '@seahorse/common';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { HasPermissionDirective, StoredAccountInfo } from '@seahorse/auth';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalAction, ModalService } from '@seahorse/temp';

@Component({
  selector: 'ca-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    HasPermissionDirective,
    NgbDropdownModule,
  ],
})
export class HeaderComponent implements OnInit, OnDestroy {
  messagingSubscription: Subscription;
  numberOfMessages;

  switchableAccounts: StoredAccountInfo[] = [];

  private _subscription = new Subscription();
  private _modalService = inject(ModalService);

  constructor(
    public router: Router,
    public routerUtil: RouterUtil,
    public identityService: IdentityService,
    public messagesInteractionService: MessagesInteractionService,
    private messagesDataService: MessagesDataService
  ) {}

  ngOnInit() {
    this.messagesDataService
      .getNumberOfUnreadMessages()
      .subscribe((response) => {
        this.numberOfMessages = response.result;
      });

    this.checkNumberOfUnreadMessages();

    this.loadSwitchableAccounts();
  }

  checkNumberOfUnreadMessages() {
    setInterval(() => {
      this.messagesDataService
        .getNumberOfUnreadMessages()
        .subscribe((response) => {
          this.numberOfMessages = response.result;
        });
    }, 10000);
  }

  getInitials() {
    let initials = '{ }';

    if (
      this.identityService.identity &&
      (this.identityService.identity.givenName ||
        this.identityService.identity.surname)
    ) {
      if (
        this.identityService.identity.givenName &&
        this.identityService.identity.givenName.length > 0 &&
        this.identityService.identity.surname &&
        this.identityService.identity.surname.length > 0
      ) {
        initials =
          this.identityService.identity.givenName.substr(0, 1) +
          this.identityService.identity.surname.substr(0, 1);
      } else if (
        this.identityService.identity.givenName &&
        this.identityService.identity.givenName.length > 0
      ) {
        initials = this.identityService.identity.givenName.substr(0, 2);
      } else if (
        this.identityService.identity.surname &&
        this.identityService.identity.surname.length > 0
      ) {
        initials = this.identityService.identity.surname.substr(0, 2);
      }
    }

    return initials;
  }

  openInboxdata() {
    this.router.navigate(['/storage/inbox/overview']);
  }

  openMessages() {
    this.router.navigate(['/messages/overview'], {
      queryParams: { type: 'outgoing' },
    });
  }

  switchToAccount(account: StoredAccountInfo) {
    this.identityService.setIdentity(account.token, true);
  }

  addAccount() {
    this.router.navigate(['/account/login']);
  }

  loadSwitchableAccounts() {
    const currentToken = this.identityService.token;

    this.switchableAccounts = this.identityService
      .getAllAccountsInfo()
      .filter((account) => account.token !== currentToken);
  }

  logOut() {
    if (!this.switchableAccounts?.length) {
      this.identityService.clearIdentity();
      return;
    }

    this._subscription.add(
      this._modalService
        .buildModal()
        .withTitle('accounts.logoutConfirmation.title')
        .withTextBody('accounts.logoutConfirmation.body')
        .open()
        .subscribe((res) => {
          if (res.action === ModalAction.Confirm) {
            this.identityService.clearIdentity();
          }

          res.modalRef.close();
        })
    );
  }

  ngOnDestroy() {
    if (this.messagingSubscription) {
      this.messagingSubscription.unsubscribe();
    }
  }
}
